import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { DataProvider } from './components/Context/Context';
import Content from './components/Content/Content'
import './App.css';
import 'bootstrap/dist/css/bootstrap.rtl.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// import 'bootstrap/dist/js/bootstrap.min.js';
import 'rc-slider/assets/index.css';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/free-mode";
import "swiper/css/effect-coverflow";
import "swiper/css/thumbs"; 

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <>
      <DataProvider>
        <BrowserRouter>

          <Content />
          
          <ToastContainer />
        </BrowserRouter>
      </DataProvider>
    </>
  );
}

export default App;
